"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
class EspoolFormValidator {
    static weight(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.WeightUnits.kg;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.WeightUnits.oz;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static extensionLength(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static trommelDiameter(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static extraLeitungLength(options) {
        var _a, _b;
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_a = options.isRequired) !== null && _a !== void 0 ? _a : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: (_b = options.isRequired) !== null && _b !== void 0 ? _b : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.CEIL,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.ft;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
}
exports.EspoolFormValidator = EspoolFormValidator;
//# sourceMappingURL=EspoolFormValidator.js.map